<script setup lang="ts">
import { useIcons } from '~/composables/useIcons';
import { computed } from 'vue';

const props = defineProps({
    name: {
        type: String,
        default: '',
    },
});

const { findIcon } = useIcons();

const icon = computed(() => findIcon(props.name));
</script>

<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span class="ui-icon" v-html="icon"></span>
</template>
